// extracted by mini-css-extract-plugin
module.exports = {"img":"Loader_img__1KoYj","wrapper":"Loader_wrapper__YL9BV"};